import { Card, Grid, pn, Stack, Typography, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { DatePicker, Select } from "components";
import { AprRequest, AprRequestFilter, AprResource, LkStudentDisplayFieldId } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const AprFilters = (props: {
  filter: AprRequestFilter;
  setFilter: (value: AprRequestFilter) => void;
  resource: AprResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties =
    props.resource.properties?.find((x) => x.propertyName === pn<AprRequest>("filter"))?.children || [];

  const aprSchoolYearField = () => {
    const propertyName = pn<AprRequestFilter>("aprSchoolYearId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.resource.aprSchoolYears?.find((x) => x.id === props.filter.aprSchoolYearId)}
        options={props.resource.aprSchoolYears}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.aprSchoolYearId = value?.id;
            })
          )
        }
      />
    );
  };

  const serviceDateFromField = () => {
    const propertyName = pn<AprRequestFilter>("serviceDateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.filter.serviceDateFrom}
        onChange={(value) => props.setFilter({ ...props.filter, serviceDateFrom: value })}
      />
    );
  };

  const serviceDateToField = () => {
    const propertyName = pn<AprRequestFilter>("serviceDateTo");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.filter.serviceDateTo}
        onChange={(value) => props.setFilter({ ...props.filter, serviceDateTo: value })}
      />
    );
  };

  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {aprSchoolYearField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          <Stack>
            {serviceDateFromField()}
            <Typography variant="caption">
              Service dates only apply to <b>Section V</b>
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {serviceDateToField()}
        </Grid>
      </Grid>
    </Card>
  );
};
